export default __webpack_public_path__ + "static/media/0xba4c54ea2d66b904c82847a7d2357d22b857e812.30458f10.png";